/**
 * Section Registry —— Section.type → Vue 组件映射（前台 ADR-0002）。
 *
 * 业务代码**禁止 `switch (type)` 分支分发 type**，所有 type → 组件
 * 解析必经 `resolveSection`。新增 Section type 只需：① 写组件 ② 在
 * 此表加一行。Registry `Object.freeze` 锁定，外部仅通过 `resolveSection`
 * 访问；不直接导出避免业务组件随手解构走旁路。
 *
 * F05 已将 issue 字面 7 个常规 type 替换为真实组件。F11 已落地 `banner`
 * （BannerSection，全宽轮播，ADR-0012）。F12 已落地 `problem` /
 * `method`（ProblemSection / MethodSection，卡片摘要 + 「更多+」，
 * ADR-0013）；`innovation` 仍走 F05 InnovationSection（F12 套 GroupSection
 * 区容器壳）。
 */
import type { Component } from 'vue';

import BannerSection from './sections/BannerSection.vue';
import IntroSection from './sections/IntroSection.vue';
import VideoSection from './sections/VideoSection.vue';
import InnovationSection from './sections/InnovationSection.vue';
import ImpactSection from './sections/ImpactSection.vue';
import GallerySection from './sections/GallerySection.vue';
import MaterialSection from './sections/MaterialSection.vue';
import StatsSection from './sections/StatsSection.vue';
import ProblemSection from './sections/ProblemSection.vue';
import MethodSection from './sections/MethodSection.vue';
import ModuleLinksSection from './sections/ModuleLinksSection.vue';
import UnknownSection from './sections/UnknownSection.vue';

const registry: Readonly<Record<string, Component>> = Object.freeze({
  banner: BannerSection,
  intro: IntroSection,
  video: VideoSection,
  'bottom-video': VideoSection,
  innovation: InnovationSection,
  impact: ImpactSection,
  gallery: GallerySection,
  material: MaterialSection,
  stats: StatsSection,
  problem: ProblemSection,
  method: MethodSection,
  'module-links': ModuleLinksSection,
});

/** Section.type → Vue Component。未注册 type 返回 UnknownSection（显式 console.warn）。 */
export function resolveSection(type: string): Component {
  return registry[type] ?? UnknownSection;
}

export { UnknownSection };
